import { FC } from 'react';

import cleanText from 'utils/cleanText';
import CommentsCharCounter from '../CommentsCharCounter';

type InputTextAreaProps = {
  id: string;
  value: string;
  label?: string;
  onChange: (value: string) => void; // eslint-disable-line
  placeholder?: string;
  infoLabel?: string;
  maxLength?: number;
  noResize?: boolean;
  lgSize?: boolean;
  showCounter?: boolean;
  communicationInput?: boolean;
  onlyInput?: boolean;
  rows?: number;
};

const InputTextArea: FC<InputTextAreaProps> = ({
  id,
  value,
  label,
  onChange,
  placeholder = '',
  infoLabel,
  maxLength,
  noResize = false,
  lgSize = false,
  showCounter = true,
  communicationInput = false,
  onlyInput = false,
  rows = 4,
}) => {
  // eslint-disable-next-line
  const handleChangeInput = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { value } = event.target;
    const sanitizedText = cleanText(value);

    onChange(sanitizedText);
  };

  const inputClassName = communicationInput
    ? 'form-control form-control-simple no-resize ex-large'
    : `form-control ${noResize ? 'no-resize h-auto' : ''} ${
        lgSize ? 'override-min-height form-control-lg' : ''
      }`;

  const textAreaComponent = (
    <textarea
      id={id}
      className={inputClassName}
      placeholder={placeholder}
      value={value}
      maxLength={maxLength}
      onChange={handleChangeInput}
      rows={rows}
    />
  );

  return (
    <>
      {communicationInput || onlyInput ? (
        textAreaComponent
      ) : (
        <div className="form-group">
          {label && (
            <label className="form-label" htmlFor={id}>
              {label}
            </label>
          )}
          <div className="form-control-wrap">
            {textAreaComponent}

            {showCounter && (
              <div
                className={`form-note d-flex ${
                  infoLabel ? 'justify-content-between' : 'justify-content-end'
                } mt-2`}
              >
                {infoLabel}
                <CommentsCharCounter comments={value} maxLength={maxLength} />
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default InputTextArea;
